import React from "react"
import { withStyles, WithStyles, createStyles, Theme } from "@material-ui/core"

import StoreButtons from "./StoreButtons"
import Description from "./Description"

const styles = ({ breakpoints: { up } }: Theme) => {
  const upMd = up("md")
  return createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: "8.75rem",
      [upMd]: {
        marginBottom: "8.5rem",
      },
    },
  })
}

interface Props extends WithStyles<typeof styles> {}

const Top = ({ classes }: Props) => {
  return (
    <div className={classes.root}>
      <Description />
      <StoreButtons />
    </div>
  )
}

export default withStyles(styles)(Top)
